/**
 * The pricing sections whose working default is a measurement the analysis did
 * not make.
 *
 * Seasonality is the one today: the analysis measures it from the property's
 * own stays, and a property with none — one that has not opened yet — comes back
 * with no seasonal multipliers at all. Such a section is asked on the essential
 * tier (`isSettingVisible`) on both surfaces, which is why the one reading of
 * the analysis lives here rather than in the wizard and the editor separately.
 *
 * Undefined before an analysis has arrived: not knowing is not the same as
 * nothing measured, and must never widen what either surface shows.
 */

import type { AnalysisResults } from "../../types/analysis";
import type { StrategySectionId } from "./strategy-section-registry";

export function unmeasuredSectionsFromAnalysis(
    results: Pick<AnalysisResults, "seasonality"> | null | undefined,
): readonly StrategySectionId[] | undefined {
    if (!results) return undefined;
    const multipliers = results.seasonality?.seasonalMultipliers;
    const seasonalityMeasured = multipliers != null && Object.keys(multipliers).length > 0;
    return seasonalityMeasured ? [] : ["seasonality"];
}

/** Whether a section was measured, given the sections the analysis did not measure. */
export function isSectionMeasured(
    section: StrategySectionId | undefined,
    unmeasuredSections: readonly StrategySectionId[] | undefined,
): boolean | undefined {
    if (!section || !unmeasuredSections) return undefined;
    return !unmeasuredSections.includes(section);
}
